import { Plus } from 'lucide-react'
import type { ComponentProps, ReactNode } from 'react'

import { cn } from '../cn'

/** Shared alignment for task Project, Lead and Client picker rows in every host. */
export function TaskRelationTrigger({
  children,
  className,
  icon = <Plus className="h-3.5 w-3.5 shrink-0" />,
  ...props
}: ComponentProps<'button'> & { icon?: ReactNode }) {
  return (
    <button
      type="button"
      className={cn(
        'flex min-h-8 w-fit max-w-full min-w-0 shrink-0 items-center gap-1.5 rounded px-2 py-1 text-left text-sm text-muted-foreground transition-colors hover:bg-muted disabled:opacity-50',
        className,
      )}
      {...props}>
      {icon}
      <span className="min-w-0 truncate">{children}</span>
    </button>
  )
}
